var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero'),_c('Search',{on:{"submitPhrase":_vm.submitPhrase}}),_c('SearchMap',{key:_vm.submitCount,attrs:{"phrase":_vm.phrase}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }